import { styled } from "@mui/material";

export const CalenderIconWrapper = styled("div")(() => ({
  marginLeft: "4px",
}));
